import type { WallCard } from '@walls/store';
import { cardLayerBaseZIndex } from '../../positioning/zIndex';
import { getCardDimensions, getCardShape, isImageCard } from './cardDisplay';

export const defaultRectangleCardWidth = 200;
export const defaultShapeCardSize = 100;

export function getCardFrameDimensions(card: WallCard, imageAspectRatio?: number) {
  const shape = getCardShape(card);

  if (shape === 'circle' || shape === 'triangle') {
    return getCardDimensions(card, defaultShapeCardSize, defaultShapeCardSize);
  }

  if (!isImageCard(card)) {
    return getCardDimensions(card, defaultRectangleCardWidth);
  }

  return getCardDimensions(
    card,
    defaultRectangleCardWidth,
    getDefaultImageCardHeight(imageAspectRatio)
  );
}

function getDefaultImageCardHeight(imageAspectRatio?: number) {
  if (!Number.isFinite(imageAspectRatio) || !imageAspectRatio || imageAspectRatio <= 0) {
    return 150;
  }

  return Math.max(80, Math.round(defaultRectangleCardWidth / imageAspectRatio));
}

export function getBoardPositionStyles(card: WallCard, isClusterChild: boolean) {
  if (isClusterChild) {
    return {
      left: undefined,
      position: 'relative' as const,
      top: undefined,
      zIndex: 3,
    };
  }

  return {
    left: card.xPos,
    position: 'absolute' as const,
    top: card.yPos,
    zIndex: card.isLocked ? Math.max(card.zPos ?? 0, cardLayerBaseZIndex) : card.zPos ?? 2,
  };
}
